import { APP_NAME, VIEW_NAME } from "scripts/router";
import SlipItemList from 'scripts/stocker/SlipItemList.svelte';
import StockList from "scripts/stocker/StockList.svelte";
import StockListTab from "scripts/stocker/StockListTab.svelte";
let app = undefined

if (APP_NAME === 'stocker' && VIEW_NAME == 'detail') {
    app = new SlipItemList({
        target: document.querySelector('.sv-component')!,
    });
} else if (APP_NAME === 'stocker' && VIEW_NAME == 'list') {
    app = new StockListTab({
        target: document.querySelector('.sv-component')!,
    });
}

export default app;